

































































































































































































































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import Tooltip from '@/components/rows/Tooltip.vue'
import { EVMTransactionResponse } from '@/store/modules/transactions/models'
import {
    DEFAULT_NETWORK_NAME,
    HAS_SUBNET,
    CURRENT_SUBNET,
} from '@/store/modules/network/network'
import Loader from '@/components/misc/Loader.vue'
import { toDCM, trimmedLocaleString } from '@/helper'
import Big from 'big.js'
import CopyText from '@/components/misc/CopyText.vue'

@Component({
    components: { Tooltip, Loader, CopyText },
    filters: {
        toDCM,
        trimmedLocaleString,
    },
})
export default class RecentTransactions extends Vue {
    chainDenomination = 9
    // forTSP = false

    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    shortenText(source: string, index: number) {
        if (index >= source.length) return source

        return `${source.substring(0, index)}...${source.substring(
            source.length - index,
            source.length
        )}`
    }

    // mounted() {
    //     if (
    //         // window.location.href.includes('blockchain') ||
    //         // localStorage.getItem('isTSP')
    //     ) {
    //         this.forTSP = true
    //     }
    // }
    get hasSubnet() {
        return HAS_SUBNET
    }
    get subnetName() {
        return CURRENT_SUBNET
    }
    amount(value: any) {
        const amt = Big(toDCM(value))
        return trimmedLocaleString(amt, this.chainDenomination)
    }

    convertToCurrency(amount: any) {
        // return Math.abs(Number(amount)) >= 1.0e9
        //     ? (Math.abs(Number(amount)) / 1.0e9).toFixed(5) + 'B'
        //     : // Six Zeroes for Millions
        //     Math.abs(Number(amount)) >= 1.0e6
        //     ? (Math.abs(Number(amount)) / 1.0e6).toFixed(5) + 'M'
        //     : // Three Zeroes for Thousands
        //     Math.abs(Number(amount)) >= 1.0e3
        //     ? (Math.abs(Number(amount)) / 1.0e3).toFixed(5) + 'K'
        //     : Math.abs(Number(amount))

        return trimmedLocaleString(amount)
    }
    get evmTransactions() {
        const block = this.$store.state.Blocks.evmBlocks
        const transactions: any[] = []
        block.map((x: any) => {
            const txCount = x.transactions.length
            let i = 0
            while (i < txCount) {
                transactions.push(x.transactions[i])
                i = i + 1
            }
        })
        return transactions
    }
    get transactions(): EVMTransactionResponse[] {
        // console.log(this.$store.state.Transactions.evmTxs)
        return this.$store.state.Transactions.evmTxs
    }
}
